<template>
  <Overlay
    ref="componentOverlayRef"
    class="overlay__container"
    :class="{
      'overlay__container__loading': state$$.currentInfoOverlay.type === 'loading'
    }"
  >
    <template #title>
      <span v-if="state$$.currentInfoOverlay.type === 'Point'">
        Información del punto
      </span>
      <span v-else-if="state$$.currentInfoOverlay.type === 'Polygon'">
        Información del polígono
      </span>
      <span v-else-if="state$$.currentInfoOverlay.type === 'layer'">
        {{ state$$.currentInfoOverlay.properties.Name }}
      </span>
      <span v-else-if="state$$.currentInfoOverlay.type === 'town'">
        {{ state$$.currentInfoOverlay.Name }}
      </span>
      <span v-else-if="state$$.currentInfoOverlay.type === 'loading'">
        Cargando
      </span>
    </template>
    <div
      v-if="state$$.currentInfoOverlay.type === 'loading'"
      class="overlay__content overlay__content__loading"
    >
      <span class="material-icons">
        rotate_right
      </span>
    </div>
    <div
      v-if="state$$.currentInfoOverlay.type === 'Point' ||
        state$$.currentInfoOverlay.type === 'Polygon'"
      class="overlay__content"
    >
      <div class="overlay__content__group">
        <span>
          <strong>¿Es necesario solicitar informe? </strong>
          {{ state$$.currentInfoOverlay.properties.isReportNeeded ? 'Sí' : 'No' }}
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.properties.intersectServidumbresAeronauticas !== null &&
          state$$.currentInfoOverlay.properties.intersectServidumbresAeronauticas !== undefined"
        class="overlay__content__group"
      >
        <span>
          <strong>Intersección con servidumbre aeronáutica: </strong>
          {{
            state$$.currentInfoOverlay.properties.intersectServidumbresAeronauticas ? 'Sí' : 'No'
          }}
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.properties.intersectHuellasRuido !== null &&
          state$$.currentInfoOverlay.properties.intersectHuellasRuido !== undefined"
        class="overlay__content__group"
      >
        <span>
          <strong>Intersección con huellas de ruido: </strong>
          {{ state$$.currentInfoOverlay.properties.intersectHuellasRuido ? 'Sí' : 'No' }}
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.properties.intersectZSA !== null &&
          state$$.currentInfoOverlay.properties.intersectZSA !== undefined"
        class="overlay__content__group"
      >
        <span>
          <strong>Intersección con área de cautela: </strong>
          {{ state$$.currentInfoOverlay.properties.intersectZSA ? 'Sí' : 'No' }}
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.type === 'Polygon' && state$$.currentInfoOverlay.area"
        class="overlay__content__group"
      >
        <span>
          <strong>Tamaño del polígono: </strong>
          {{ state$$.currentInfoOverlay.area }}m<sup>2</sup>
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.type === 'Point' && state$$.currentInfoOverlay.coordinate"
        class="overlay__content__group"
      >
        <span>
          <strong>Coords (lat, long): </strong>
          {{ state$$.currentInfoOverlay.coordinate.lat.toFixed(6) }}
          {{ state$$.currentInfoOverlay.coordinate.lon.toFixed(6) }}
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.properties.clearance"
        class="overlay__content__group"
      >
        <span>
          <strong>Altura libre: </strong>
          {{ state$$.currentInfoOverlay.properties.clearance }}
        </span>
        <span
          v-if="state$$.currentInfoOverlay.properties.isClearanceNegative ||
            !state$$.currentInfoOverlay.properties.isClearanceAvailable"
          class="material-icons icon-help"
          @mouseover="onMouseOverItem"
          @mouseleave="onMouseLeaveItem"
        >
          error_outline
        </span>
        <div
          class="overlay__content__group__helper"
          :class="{'overlay__content__group__helper--open': showHelperRef}"
        >
          <p v-if="computedClearanceMessage">
            {{ computedClearanceMessage }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-else-if="state$$.currentInfoOverlay.type === 'layer'"
      class="overlay__content"
    >
      <div
        v-if="state$$.currentInfoOverlay.properties.Elevation"
        class="overlay__content__group"
      >
        <span>
          <strong>Elevación: </strong>
          {{ state$$.currentInfoOverlay.properties.Elevation }}m
        </span>
      </div>
      <div
        class="overlay__content__group"
      >
        <span>
          <strong>Código: </strong>
          {{ state$$.currentInfoOverlay.properties.Code }}
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.properties.RealDecretoUrl"
        class="overlay__content__group"
      >
        <span>
          <strong>Real decreto: </strong>
          <a
            rel="noopener"
            :href="state$$.currentInfoOverlay.properties.RealDecretoUrl"
            target="_blank"
          >Enlace</a>
        </span>
      </div>
      <div
        v-if="state$$.currentInfoOverlay.properties.PlanDirectorUrl"
        class="overlay__content__group"
      >
        <span>
          <strong>Plan director: </strong>
          <a
            rel="noopener"
            :href="state$$.currentInfoOverlay.properties.PlanDirectorUrl"
            target="_blank"
          >Enlace</a>
        </span>
      </div>
      <div
        class="overlay__content__group"
      >
        <span>
          <strong>Coords (lat, long): </strong>
          {{ state$$.currentInfoOverlay.coordinate.lat.toFixed(6) }},
          {{ state$$.currentInfoOverlay.coordinate.lon.toFixed(6) }}
        </span>
      </div>
    </div>
    <div
      v-else-if="state$$.currentInfoOverlay.type === 'town'"
      class="overlay__content"
    >
      <div
        class="overlay__content__group"
      >
        <span>
          <strong>¿Es necesario solicitar informe? </strong>
          {{ state$$.currentInfoOverlay.properties.isReportNeeded ? 'Sí' : 'No' }}
        </span>
      </div>
      <div
        class="overlay__content__group"
      >
        <span>
          <strong>Intersección con servidumbre aeronáutica: </strong>
          {{
            state$$.currentInfoOverlay.properties.intersectServidumbresAeronauticas ? 'Sí' : 'No'
          }}
        </span>
      </div>
      <div
        class="overlay__content__group"
      >
        <span>
          <strong>Intersección con huellas de ruido: </strong>
          {{
            state$$.currentInfoOverlay.properties.intersectHuellasRuido ? 'Sí' : 'No'
          }}
        </span>
      </div>
      <div
        class="overlay__content__group"
      >
        <span>
          <strong>Intersección con área de cautela: </strong>
          {{
            state$$.currentInfoOverlay.properties.intersectZSA ? 'Sí' : 'No'
          }}
        </span>
      </div>
    </div>
    <div
      v-if="state$$.currentInfoOverlay.type === 'Point' ||
        state$$.currentInfoOverlay.type === 'Polygon'"
      class="overlay__content__group-button"
    >
      <Button
        class="overlay__content__group-button__button"
        :disabled="state$$.currentInfoOverlay.isLoading"
        @click="onClickDownload"
      >
        <span
          v-if="state$$.currentInfoOverlay.isLoading"
          class="material-icons icon-loader"
        >
          rotate_right
        </span>
        <span v-if="state$$.currentInfoOverlay.isLoading">
          Generando informe...
        </span>
        <span v-else>
          Descargar informe
        </span>
      </Button>
    </div>
  </Overlay>
</template>


<script setup>
import {ref, inject, onMounted, computed} from 'vue';
import Overlay from '@/components/overlay-map/Overlay';
import Button from 'primevue/button';

// import {getDisclaimerByKey} from '@/api/visor/literal/literal.api';
import {screenhotToBlob} from '@/composables/screenshot';
import {saveAs} from 'file-saver';
import {generatePdf} from '@/api/visor/pdf/pdf.api';
import {getCenter, getArea, getTopLeft, getBottomRight} from 'ol/extent';
import {LineString} from 'ol/geom';

import {STYLE_DEFAULT, STYLE_INVISIBLE} from './styles.config-styles';

// #region Props, Emits
// ...
// #endregion


// #region Params, Ref, Reactives, Computed
const state$$ = inject('state$$');
const instanceMapRef = inject('instanceMapRef');
const GROUP_DRAW = inject('GROUP_DRAW');
const modelMapRef = inject('modelMapRef');


const componentOverlayRef = ref();
const showHelperRef = ref(false);
const textNoClearanceRef = ref('');
const textNegativeClearanceRef = ref('');
const featuresVisiblesRef = ref([]);

const computedClearanceMessage = computed(() => {
  if (state$$.currentInfoOverlay.properties.isClearanceNegative) {
    return textNegativeClearanceRef.value;
  } else if (!state$$.currentInfoOverlay.properties.isClearanceAvailable) {
    return textNoClearanceRef.value;
  }
  return null;
});
// #endregion


// #region Functions
function setPosition(coordinate) {
  componentOverlayRef.value.overlay.setPosition(coordinate);
}

/**
 * When the mouse is over the icon change the status of showHelpRef
 * to show the disclaimer
 *
 */
function onMouseOverItem() {
  showHelperRef.value = true;
}

/**
 * When the mouse is over the icon change the status of showHelpRef
 * to hide the disclaimer
 *
 */
function onMouseLeaveItem() {
  showHelperRef.value = false;
}

/**
 * Request to download the report
 *
 */
async function onClickDownload() {
  state$$.currentInfoOverlay.isLoading = true;
  const mapImage = await getMapImageToBlob();

  const params = {
    ImageMap: new Blob([mapImage], {type: 'image/png'}),
  };

  const guid = state$$.currentInfoOverlay.feature.getProperties().request.guid;
  const responsePDF = await generatePdf(guid, params);

  if (responsePDF) {
    const {request, data} = responsePDF;
    const header = request.getResponseHeader('content-disposition');
    const contentHeader = header.split('; ');

    let name = '';
    for (const item of contentHeader) {
      const [key, value] = item.split('=');
      if (key === 'filename') {
        name = value;
        break;
      }
    }

    saveAs(data, `${name}`);
  }
  state$$.currentInfoOverlay.isLoading = false;
}

function hideFeatures() {
  featuresVisiblesRef.value = [];
  GROUP_DRAW.getLayers()?.getArray()[0]?.getSource()
    .forEachFeature((feature) => {
      if (state$$.currentInfoOverlay.feature !== feature &&
        feature.getStyle().getFill().getColor() === STYLE_DEFAULT.getFill().getColor()) {
        featuresVisiblesRef.value.push(feature);
      }
    });
  featuresVisiblesRef.value.forEach((feature) => {
    feature.setStyle(STYLE_INVISIBLE);
  });
}

function showFeatures() {
  featuresVisiblesRef.value.forEach((feature) => {
    feature.setStyle(STYLE_DEFAULT);
  });
  featuresVisiblesRef.value = [];
}

/**
 * Do the capture of map like image
 *
 * @return {Promise}
 * @resolve {Blob}
 */
function getMapImageToBlob() {
  return new Promise(async (resolve) => {
    state$$.isDownloadingPDF = true;
    hideFeatures();
    const {feature} = state$$.currentInfoOverlay;
    const center = getCenter(feature.getGeometry().getExtent());
    const area = getArea(feature.getGeometry().getExtent());

    // Se crea una linea para obtener el tamaño del rectángulo que genera el bounding
    const topLeft = getTopLeft(feature.getGeometry().getExtent());
    const bottomRight = getBottomRight(feature.getGeometry().getExtent());
    const line = new LineString([topLeft, bottomRight]);

    const pdfHeight = modelMapRef.value.pdf.height;

    let zoom = 18;

    if (area) {
      if (area > 8000000 || line.getLength() > (pdfHeight * 3)) {
        zoom = 14;
      } else if (area > 3200000 || line.getLength() > (pdfHeight * 2)) {
        zoom = 15;
      } else if (area > 450000 || line.getLength() > pdfHeight) {
        zoom = 16;
      } else if (area > 90000) {
        zoom = 17;
      }
    }

    instanceMapRef.value.getView().setZoom(zoom);
    instanceMapRef.value.getView().setCenter(center);


    setTimeout(() => {
      instanceMapRef.value.once('rendercomplete', async () => {
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;

        let width = modelMapRef.value.pdf.width / window.devicePixelRatio;
        let height = modelMapRef.value.pdf.height / window.devicePixelRatio;
        if (windowHeight < height) {
          height = windowHeight;
        }
        if (windowWidth < width) {
          width = windowWidth;
        }
        const [pixelX, pixelY] = instanceMapRef.value.getPixelFromCoordinate(center);

        const left = pixelX - (width/2);
        const top = pixelY - (height/2);

        const capture = await screenhotToBlob({
          x: left,
          y: top,
          selector: '.ol-unselectable',
          width,
          height,
        });
        state$$.isDownloadingPDF = false;
        showFeatures();
        resolve(capture);
      });
      instanceMapRef.value.renderSync();
    }, 700);
  });
}

// #endregion


// #region Effects, Hooks
onMounted(async () => {
  // textNoClearanceRef.value = (await getDisclaimerByKey('Disclaimer_NoClearance')).value;
  // textNegativeClearanceRef.value =
  // (await getDisclaimerByKey('Disclaimer_NegativeClearance')).value;
  setTimeout(() => {
    instanceMapRef.value.addOverlay(componentOverlayRef.value.overlay);
  }, 1000);
});
// #endregion


// #region Provide, Expose
defineExpose({
  setPosition,
});
// #endregion
</script>


<style lang="scss" scoped>
.overlay__container {
  &__loading {
    width: 100px;
  }
}

.overlay__content {
  font-size: 0.9rem;

  &__group {
    margin-top: 8px;
    font-size: 0.9em;
    display: flex;
    position: relative;
    width: fit-content;

    &__helper {
      position: absolute;
      left: 100%;
      top: 100%;
      padding: 5px;
      width: 300px;
      background-color: rgba($brand__color--white, 0.8);
      box-shadow: 0 1px 4px rgba($brand__color--black,0.2);
      border-radius: 0.25rem;
      border: 1px solid $brand__color--smoke;
      display: none;
      z-index: 9999;

      &--open {
        display: block;
      }
    }

    &-button {
      margin-top: 10px;
      display: flex;
      width: 100%;

      &__button {
        width: 100%;
      }
    }
  }

  &__loading {
    display: flex;
    justify-content: center;
    align-items: center;

    & > span {
      font-size: 3rem;
      animation-name: loader;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      color: $brand__color--blue;
    }
  }
}

.icon-help {
  margin-left: 5px;
  font-size: 1rem;
  cursor: help;
}

.icon-loader {
  display: flex;
  align-items: center;
  animation-name: loader;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes loader {
  to { transform: rotate(360deg) }
}

</style>
